// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"607":"78ba196e","668":"c7cfd08c","787":"a16a2c91"}[chunkId] + ".chunk.js";
};